import React from 'react';
import {Media, MediaImg, MediaBody} from './styles';
import DefaultAvatar from '../../assets/icons/defaultAvatar.png';

export default ({
  name,
  imgUrl,
  max = '',
  size = '29px',
  mRight = '14px',
  fontSize = '16px',
  padding,
}: {
  name?: string;
  max?: string;
  size?: string;
  imgUrl?: string;
  mRight?: string;
  fontSize?: string;
  padding?: string;
}) => (
  <Media padding={padding}>
    <MediaImg size={size} mRight={mRight}>
      <img src={imgUrl ? imgUrl : DefaultAvatar} alt="Avatar" />
    </MediaImg>
    {name && (
      <MediaBody fontSize={fontSize} max={max}>
        {name}
      </MediaBody>
    )}
  </Media>
);
